const CookieName = Object.freeze({
  DOCUMENT_LOCATION: "document-location-state",
});

export { CookieName };
